(() => {
  const layout3Container = $(".product-form-standardSelector.layout3");
  const isLayout3 = layout3Container.length > 0;

  const container = $(".solaris-accs-addon-container");
  if (!container.length) return;

  const MAX_QTY = 1000000;
  const selectedVariantOutput = container.find(".selected_variantId");

  /* ===============================
     VARIANT MAP
  =============================== */

  const ADDON_VARIANTS = {
    "1M": {
      rod: {
        white: "47816238891235",
        grey: "47816238956771",
      },
      rod_clips: {
        white: "47880184594659",
        grey: "47880191148259",
      },
    },
    XL: {
      rod: {
        white: "47816238924003",
        grey: "47816238989539",
      },
      rod_clips: {
        white: "47880191115491",
        grey: "47880191181027",
      },
    },
  };

  const BUNDLED_VARIANTS = {
    "1M": {
      rod_clips: {
        white: {
          rod: "47880218575075",
          clips: { id: "47880218607843", perUnit: 6 },
        },
        grey: {
          rod: "47880223719651",
          clips: { id: "47880218607843", perUnit: 6 },
        },
      },
    },
    XL: {
      rod_clips: {
        white: {
          rod: "47880219394275",
          clips: { id: "47880218607843", perUnit: 7 },
        },
        grey: {
          rod: "48315547910371",
          clips: { id: "47880218607843", perUnit: 7 },
        },
      },
    },
  };

  /* ===============================
     HELPERS
  =============================== */

  function getRackLength() {
    if (isLayout3) {
      const active = layout3Container.find(
        ".option-wrapper[data-type='rack_length'] .item.active"
      );

      if (active.length) {
        const value = active.data("value") || "";
        return value.includes("XL") ? "XL" : "1M";
      }
    }

    const activeItem = $(".select-wrapper .item.active[data-product_title]");
    if (!activeItem.length) return null;

    return activeItem.attr("data-product_title").includes("XL")
      ? "XL"
      : "1M";
  }

  function getMainSelectedColor() {
    if (isLayout3) {
      const active = layout3Container.find(
        ".option-wrapper[data-type='rack_color'] .item.active"
      );

      if (active.length) {
        return active.data("value").toLowerCase().includes("grey")
          ? "grey"
          : "white";
      }
    }

    const $checked = $('.select-wrapper.color-wrapper input[name="variant"]:checked');
    if (!$checked.length) return "white";

    return $checked.attr("data-variant_title").toLowerCase().includes("grey")
      ? "grey"
      : "white";
  }

  function enforceQtyLimit($input) {
    let qty = Number($input.val()) || 0;
    qty = Math.max(0, Math.min(MAX_QTY, qty));
    $input.val(qty);
  }

  function updateQtyButtons($addon) {
    const qty = Number($addon.find("input[name='addon-qty']").val()) || 0;
    $addon.find(".qty-increase").toggleClass("disabled", qty >= MAX_QTY);
    $addon.find(".qty-decrease").toggleClass("disabled", qty <= 0);
  }

  function updateAddonImage($addon) {
    const color = getMainSelectedColor();
    const $label = $addon.find(`label[data-color="${color}"]`);
    if (!$label.length) return;

    $label.find("input").prop("checked", true);

    const img = $label.attr("data-image");
    if (img) {
      $addon.find(".image-wrapper").show();
      $addon.find("img.prod-img").attr("src", img);
    }
  }

  function updateBundledVariantIds($addon) {
    const $current = $("#currentSelection");

    if (
      !$addon.find("[name='solaris_accs_select']").is(":checked") ||
      $addon.data("addon-type") !== "rod_clips"
    )
      return;

    const length = $addon.data("length");
    const color = getMainSelectedColor();
    const qty = Number($addon.find("input[name='addon-qty']").val()) || 0;

    const bundle = BUNDLED_VARIANTS?.[length]?.rod_clips?.[color];
    if (!bundle) return;

    const rod = `${bundle.rod}-${qty}`;
    const clips = `${bundle.clips.id}-${bundle.clips.perUnit * qty}`;

    // const existing = $current.attr("data-bundled-variant-ids") || "";
    const existing = ""; // 20260525 – fix wrong qty added for rods and clips

    const newValue = [existing, rod, clips]
      .filter(Boolean)
      .join(",");

    $current.attr("data-bundled-variant-ids", newValue);
  }

  function updateAddonVisibility() {
    const length = getRackLength();
    if (!length) return;

    container.find(".addon-item").each(function () {
      const $addon = $(this);

      if ($addon.data("length") === length) {
        $addon.removeClass("hide");
        updateAddonImage($addon);
        updateQtyButtons($addon);
      } else {
        $addon.addClass("hide");
        $addon.find("[name='addon-qty']").val(0);
      }
    });

    selectedVariantOutput.text("");
    $("#currentSelection").removeAttr("data-bundled-variant-ids");
  }

  function updateSelectedVariants() {
    const selections = [];

    container.find(".addon-item:visible").each(function () {
      const $addon = $(this);
      if (!$addon.find("[name='solaris_accs_select']").is(":checked")) return;

      updateBundledVariantIds($addon);

      const length = $addon.data("length");
      const type = $addon.data("addon-type");
      const color = getMainSelectedColor();
      const qty = Number($addon.find("input[name='addon-qty']").val()) || 0;

      const variantId = ADDON_VARIANTS?.[length]?.[type]?.[color];
      if (variantId) selections.push(`${variantId}-${qty}`);
    });

    selectedVariantOutput.text(selections.join(","));
  }

  function triggerAddonUpdate() {
    updateAddonVisibility();
    updateSelectedVariants();
  }

  function triggerColorUpdate() {
    container.find(".addon-item:visible").each(function () {
      updateAddonImage($(this));
      updateBundledVariantIds($(this));
    });

    updateSelectedVariants();
  }

  function updatePreOrderText() {
    const activeItem = $(".select-wrapper .item.active");

    const isStandard =
      activeItem.attr("data-product_title")?.includes("Standard");

    $(".pre-order-text").toggleClass("hide", !isStandard);
  }

  /* ===============================
     EVENTS
  =============================== */

  container.on("click", "[name='solaris_accs_select']", function () {
    $(this).prop("checked", true);
    updateSelectedVariants();
  });

  container.on("click", ".qtyBtn", function (e) {
    e.preventDefault();
    if ($(this).hasClass("disabled")) return;

    const $addon = $(this).closest(".addon-item");
    const $input = $addon.find("input[name='addon-qty']");
    let qty = Number($input.val()) || 0;

    if ($(this).hasClass("qty-increase")) qty++;
    if ($(this).hasClass("qty-decrease")) qty--;

    $input.val(Math.max(0, Math.min(MAX_QTY, qty)));
    updateQtyButtons($addon);
    updateSelectedVariants();
  });

  container.on("change", "[name='addon-qty']", function () {
    const $addon = $(this).closest(".addon-item");
    enforceQtyLimit($(this));
    updateQtyButtons($addon);
    updateSelectedVariants();
  });

  // OLD SYSTEM
  $(".select-wrapper").on("click", ".item", function () {
    $(this).closest(".select-wrapper").find(".item").removeClass("active");
    $(this).addClass("active");

    triggerAddonUpdate();
    updatePreOrderText();
  });

  $(".select-wrapper.color-wrapper").on(
    "change",
    'input[name="variant"]',
    triggerColorUpdate
  );

  // NEW SYSTEM
  $(document).on(
    "click",
    ".product-form-standardSelector.layout3 .item",
    function () {
      setTimeout(triggerAddonUpdate, 0);
    }
  );

  $(document).on(
    "click",
    ".product-form-standardSelector.layout3 .option-wrapper[data-type='rack_color'] .item",
    function () {
      setTimeout(triggerColorUpdate, 0);
    }
  );

  /* ===============================
     INIT
  =============================== */

  triggerAddonUpdate();
  updatePreOrderText();

  $(".solaris-accs-addon-container").on("click", ".addon-item", function () {
  window._skipGlobalDeselect = true;

  setTimeout(() => {
    window._skipGlobalDeselect = false;
  }, 0);
});
  // auto select all addons
  $("[name='solaris_accs_select']").click();

})();